import { mapActions } from "vuex"

import directional_swipe from "~/components/transitions/directionalSwipe"
import account_swapper from "~/components/nav/loggedIn/contextMenu/accountSwapper"

export default {
  components: {
    account_swapper,
    directional_swipe,
  },
  data: function () {
    return {
      displayAccSwapper: false,
      unsubscribe_handler: function () {},
    }
  },
  mounted: function () {
    this.unsubscribe_handler = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "login/DISPLAY") {
        this.displayAccSwapper = false
        this.$emit("close")
      }
    })
  },
  beforeDestroy: function () {
    this.unsubscribe_handler()
  },
  computed: {
    transition_direction: function () {
      return this.displayAccSwapper ? 1 : -1
    },
  },
  methods: {
    ...mapActions({
      login_request_account_swap: "login/REQUEST_ACCOUNT_SWAP",
    }),
  },
}
